import { render, staticRenderFns } from "./fligthpath-connection-status.vue?vue&type=template&id=13953cb8&scoped=true"
import script from "./fligthpath-connection-status.vue?vue&type=script&lang=ts"
export * from "./fligthpath-connection-status.vue?vue&type=script&lang=ts"
import style0 from "./fligthpath-connection-status.vue?vue&type=style&index=0&id=13953cb8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13953cb8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13953cb8')) {
      api.createRecord('13953cb8', component.options)
    } else {
      api.reload('13953cb8', component.options)
    }
    module.hot.accept("./fligthpath-connection-status.vue?vue&type=template&id=13953cb8&scoped=true", function () {
      api.rerender('13953cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flightpath-components/lib-components/fligthpath-connection-status.vue"
export default component.exports